import {
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { sqlServerMetadata } from './sql-server-metadata';
import { IRadioOption, ISelectOption, Metamodel, ModelConstants } from 'shell-models-lib';
import { MountedRelationalDatabaseTableCopySink } from 'app/model/pipeline/copysink/mounted-relational-database-table.copysink';

export type MountedRelationalDatabaseOperationType = 'Column' | 'Default';

export const mountedRelationalDatabaseMetadata: ILinkedServiceTypeMetadata = {
    ...sqlServerMetadata,
    copyJob: { ...sqlServerMetadata.copyJob, omitConnectionDatabaseFromDataset: false },
    type: adfModelTypeMap.mountedRelationalDatabase.linkedServiceType,
    displayName: stringResources.Mounted_Relational_Database_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i_mirroredDatabase'
    },
    category: ['Workspace'],

    copySourceTypes: [],
    copySinkTypes: [Metamodel.modelFor(MountedRelationalDatabaseTableCopySink).name],
    supportDataFlowSource: false,
    supportDataFlowSink: false,
    dataflowSource: undefined,
    dataflowSink: undefined,

    supportCopyJobSource: false,
    supportCopyJobSink: false,

    pqoDataSourceOption: undefined,
    fabricArtifactType: ModelConstants.mountedRelationalDatabaseArtifactType,
    isKnownInPipelineContext: false,

    controls: [],
    additionalPropertiesInFabric: undefined
};

export const mountedRelationalDatabaseOptions: Array<IRadioOption<MountedRelationalDatabaseOperationType>> = [
    {
        label: stringResources.ColumnBasedRowMarker,
        value: 'Column'
    },
    {
        label: stringResources.DefaultRowMarker,
        value: 'Default'
    }
];

export enum DefaultRowMarker {
    None = 'NONE',
    Insert = 'insert',
    Update = 'update',
    Delete = 'delete',
    Upsert = 'upsert'
}

export const defaultRowMarkerOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.WriteBehavior_Option_Insert,
        value: DefaultRowMarker.Insert
    },
    {
        label: stringResources.Update,
        value: DefaultRowMarker.Update
    },
    {
        label: stringResources.Delete,
        value: DefaultRowMarker.Delete
    },
    {
        label: stringResources.WriteBehavior_Option_Upsert,
        value: DefaultRowMarker.Upsert
    }
];
